






































import {Component, Vue} from 'vue-property-decorator';
import CoolantDiagram from '@c/services/coolant/CoolantDiagram.vue';
import ServiceSettingsSelectBox from '@c/ServiceSettingsSelectBox.vue';
import {DateTimeInterval} from '@u/dateTimeItervalUtils';
import DiagramLegendNoCard from '@c/diagrams/DiagramLegendNoCard.vue';
import {requestCoolantData} from '@api/services/coolantApi';
import {DiagramData} from '@/interfaces/diagrams';
import {
  statusDiagramColorScheme as colorScheme,
  machineWorkingStatusTitles as titleScheme,
} from '@/components/system/configurate';
import {SystemNode} from '@/components/system/interfaces';
import Loading from '@c/controls/Loading.vue';
import {Can} from '@casl/vue';
import {uuidv4} from '@/utils/uuidUtils';

@Component({
  components: {
    CoolantDiagram,
    ServiceSettingsSelectBox,
    DiagramLegendNoCard,
    Loading,
    Can,
  },
})
export default class CoolantView extends Vue {
  //показатели загрузки данных и наличия ошибок получения данных с сервера
  coolantLoading = false;
  coolantError = false;

  //основной график
  chartData: DiagramData = {
    data: [],
    yAxis: {name: '', units: ''},
    name: '',
    id: '',
    visible: true,
  };

  //скрытый график для областей без данных
  extendChartData: any[] = [];

  //фон графика
  plotBands: any[] = [];

  //дополнительные линии
  plotLines: any[] = [];

  //минимальное значение масштаба по оси X (мс)
  xMinScaleValue = 1000;

  //сохранненный интервал, нужен при сбросе зума
  backupDateTime: DateTimeInterval | any = {};

  selectedMachine!: SystemNode;

  //данные для легенды
  legendInfo = [
    {color: colorScheme.off, name: titleScheme.off},
    {color: colorScheme.idle, name: titleScheme.idle},
    {color: colorScheme.work, name: titleScheme.work},
    {color: colorScheme.incorrect, name: titleScheme.incorrect},
  ];

  //цвета для фона
  colorsBgInterval = [colorScheme.off, colorScheme.idle, colorScheme.work, colorScheme.incorrect];

  //цвета для линий
  colorsBorder = [colorScheme.off, colorScheme.idle, colorScheme.work, colorScheme.incorrect];

  // Показатель применения зума
  isInZoom = false;

  async returnInitialStateChart() {
    if (this.isInZoom) {
      await this.getData(this.selectedMachine, this.backupDateTime);
      this.isInZoom = false;
    }
  }

  async getDataWithTimeFromComponent(serviceSettings: {
    machine: SystemNode;
    dateInterval: DateTimeInterval;
  }) {
    this.backupDateTime = serviceSettings.dateInterval;
    this.selectedMachine = serviceSettings.machine;
    await this.getData(serviceSettings.machine, serviceSettings.dateInterval);
  }

  async onZoom(dateInterval: DateTimeInterval) {
    await this.getData(this.selectedMachine, dateInterval);
  }

  async getData(machine: SystemNode, dateInterval: DateTimeInterval) {
    this.isInZoom = true;
    //мс в сек. для отправки на сервер

    const startDate = dateInterval.startDateTime as number;
    const endDate = dateInterval.endDateTime as number;

    this.coolantLoading = true;
    this.coolantError = false;
    requestCoolantData(machine.id, startDate, endDate)
      .then((res: any) => {
        const {series, intervalsModes} = res;
        this.chartData = {
          data: series,
          yAxis: {name: 'Уровень жидкости, л/мин', units: 'л/мин'},
          name: '',
          id: uuidv4(),
          visible: true,
        };
        this.extendChartData = [
          {x: dateInterval.startDateTime, y: 0},
          {x: dateInterval.endDateTime, y: 1},
        ];

        this.plotBands = intervalsModes.map((elem: any) => ({
          color: this.colorsBgInterval[elem.mode],
          from: elem.from,
          to: elem.to,
          zIndex: 0,
        }));

        this.plotLines = intervalsModes.map((elem: any) => ({
          color: this.colorsBorder[elem.mode],
          value: elem.to,
          width: 2,
          zIndex: 0,
        }));
      })
      .catch(() => {
        this.coolantError = true;
      })
      .finally(() => {
        this.coolantLoading = false;
      });
  }
}
